import type { BusinessGoalV1 } from "@adpilot/shared";

export type SetupStep = "policy" | "review" | "success";
export type AiPolicyDialogPurpose = "setup" | "edit";

export const GOAL_OPTIONS: Array<{
  value: BusinessGoalV1;
  labelKey: string;
  descriptionKey: string;
}> = [
  {
    value: "improve_efficiency",
    labelKey: "goals.improve_efficiency.label",
    descriptionKey: "goals.improve_efficiency.description",
  },
  {
    value: "grow_sales",
    labelKey: "goals.grow_sales.label",
    descriptionKey: "goals.grow_sales.description",
  },
  {
    value: "explore_and_learn",
    labelKey: "goals.explore_and_learn.label",
    descriptionKey: "goals.explore_and_learn.description",
  },
  {
    value: "defend_branded_traffic",
    labelKey: "goals.defend_branded_traffic.label",
    descriptionKey: "goals.defend_branded_traffic.description",
  },
  {
    value: "launch_product",
    labelKey: "goals.launch_product.label",
    descriptionKey: "goals.launch_product.description",
  },
  {
    value: "clear_inventory",
    labelKey: "goals.clear_inventory.label",
    descriptionKey: "goals.clear_inventory.description",
  },
];

export const SETUP_STEP_INDEX: Record<SetupStep, number> = {
  policy: 0,
  review: 1,
  success: 2,
};
